import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function FeaturedSections() {
  const { t } = useTranslation();

  return (
    <>
      <section id="featured" className="bg-background-50">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-20">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
            <div className="overflow-hidden rounded-lg border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20tidy%20stack%20of%20folded%20pastel%20knit%20sweaters%20with%20a%20small%20potted%20plant%20on%20a%20light%20warm%20neutral%20studio%20surface%2C%20soft%20beige%20and%20sage%20tones%2C%20gentle%20diffused%20daylight%2C%20subtle%20soft%20shadow%2C%20minimalist%20editorial%20apparel%20product%20photography%20with%20fresh%20clean%20aesthetic%20and%20negative%20space&width=1200&height=900&seq=featured-usfans-01&orientation=landscape&nocache=true"
                alt="USFans Spreadsheet guide"
                title="USFans Spreadsheet guide and resources"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div>
              <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl font-heading">{t('featuredTitle')}</h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">{t('featuredCopy')}</p>
              <Link
                to="/usfans-spreadsheet-guide"
                className="mt-6 inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600 whitespace-nowrap cursor-pointer"
              >
                {t('readGuide')}
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section id="review" className="bg-background-100">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-20">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
            <div className="rounded-lg border border-background-200 bg-background-50 p-8">
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                <i className="ri-star-line text-xl"></i>
              </span>
              <h2 className="mt-4 text-2xl font-bold text-foreground-950 font-heading">{t('reviewTitle')}</h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{t('reviewCopy')}</p>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-primary-700 hover:text-primary-800 whitespace-nowrap cursor-pointer"
              >
                {t('readReview')}
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            <div id="safety" className="rounded-lg border border-background-200 bg-background-50 p-8">
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                <i className="ri-shield-check-line text-xl"></i>
              </span>
              <h2 className="mt-4 text-2xl font-bold text-foreground-950 font-heading">{t('safetyTitle')}</h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{t('safetyCopy')}</p>
              <a
                href="#safety"
                className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-secondary-700 hover:text-secondary-800 whitespace-nowrap cursor-pointer"
              >
                {t('readSafety')}
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}